<template>
    <option value="eq">equals</option>
    <option value="gt">greater than</option>
    <option value="lt">less than</option>
    <option value="btw">between (inclusive)</option>
    <option value="ne">does not equal</option>
</template>
